import { Component, OnInit } from '@angular/core';
import { IndicationDefinition, IndicationGroup } from '@app/models/indication';
import { SharedService } from '@app/services/shared.service';

@Component({
  selector: 'app-summary-section',
  templateUrl: './summary-section.component.html',
  styleUrls: ['./summary-section.component.css']
})
export class SummarySectionComponent implements OnInit {

  allIndications: IndicationGroup[] = [];
  flattenedIndications: IndicationDefinition[] = [];
  selectedFiltersFromLastRanQuery: IndicationDefinition[] = [];
  selectedDataSetsFromLastRanQuery: any = [];
  showSummarySection = false;
  summaryData: any = [];

  constructor(private readonly sharedService: SharedService) { }

  ngOnInit() {
    this.sharedService.allIndications.subscribe(data => {
      if (data) {
        this.allIndications = data;
        this.setFlattenedIndications();
      }
    });

    this.sharedService.lastExecutedQueryInfo.subscribe(data => {
      if (data) {
        this.selectedFiltersFromLastRanQuery = data['selectedFilters'];
        this.selectedDataSetsFromLastRanQuery = data['selectedDataSets'];
        this.showSummarySection = true;
        this.displaySummarySectionInfo();
      }
    });

    this.sharedService.resetQuery.subscribe(reset => {
      if (reset) {
        this.selectedFiltersFromLastRanQuery = [];
        this.selectedDataSetsFromLastRanQuery = [];
        this.showSummarySection = false;
      }
    });
  }

  displaySummarySectionInfo(): void {
    this.summaryData = [];
    var selectedIndications = [];
    var selectedDetails = [];
    [].slice.call(document.getElementsByClassName('indication-selection-section')).forEach(el1 => {
      [].slice.call(el1.getElementsByClassName('indication-selection-name')).forEach(el2 => {
        selectedIndications.push(el2.innerText);
      });
      [].slice.call(el1.getElementsByClassName('indication-selection-details')).forEach(el2 => {
        selectedDetails.push(el2.innerText);
      });
    });

    var summarySelections = [];
    for(var i = 0; i < selectedIndications.length; i++) {
      var summaryCombo = {
        indication: selectedIndications[i],
        details: selectedDetails[i].split('\n'),
        inclusionCriteria: this.flattenedIndications.find(x => x.displayName === selectedIndications[i]).inclusionCriteria.split(';')
      };
      summarySelections.push(summaryCombo);
    }

    this.summaryData = summarySelections;
    this.sharedService.setSummarySectionInfo(this.summaryData);
  }

  setFlattenedIndications(): void {
    this.flattenedIndications = [];
    this.allIndications.forEach(group => {
      group.indications.forEach(i => {
        this.flattenedIndications.push(i);
      });
    });
  }

}
